import { render, staticRenderFns } from "./DefinitionListSelector.vue?vue&type=template&id=4e02e9d6&"
import script from "./DefinitionListSelector.vue?vue&type=script&lang=ts&"
export * from "./DefinitionListSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
